import PropertyViewCell from './components/PropertyViewCell';
export default PropertyViewCell;